// 尺寸454*320
import React, { useRef, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  SettingOutlined,
  CheckOutlined,
  ExclamationOutlined,
  RollbackOutlined,
  PrinterOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { Button, Row, Col, Input, ConfigProvider, Modal, Select, Steps, Image } from 'antd'
import { Modal as ModalMobile } from 'antd-mobile'
import { formatMessageNew, downloadTem } from '@/utils/common'
import { modalErrorRefreshCode, messageModal, modalConfirm, modalInfo, modalError } from '@/utils/modalUtils'
import { BrowserPrint } from '@/utils/BrowserPrint-3.0.216.min'
import { clearAuthentication } from '@/utils/authHelp'
import {
  setPrintConfig,
  getPrintConfig,
  checkPrinterStatus,
  relabelValidUpc,
  relabelValidQrCode,
  relabelPrint,
  getReprintInfo
} from '@/services/reprint/reprint'
import { getAppData, onAppData, setReadSetting, onScanBarcodeResult, setKeyCall, onKeyMsg } from '@/services/rfEpc'
import { resIPV4 } from '@/utils/regUtils'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import TipImg from '@/assets/images/tip.png'
import PrintStep1 from '@/assets/images/print/printStep1.png'
import PrintStep2 from '@/assets/images/print/printStep2.png'
import PrintStep3 from '@/assets/images/print/printStep3.png'
import PrintStep4 from '@/assets/images/print/printStep4.png'
import PrintStep5 from '@/assets/images/print/printStep5.png'
import '@/pages/AndroidDevice/PhoneLayout.less'
import { isExtranetHostname } from '@/utils/hostEnv'
let errorNum = 0
let selecteOptions = [
  {
    label: '1025',
    value: '1025'
  },
  {
    label: '1027',
    value: '1027'
  }
]
// 设置全局链接状态-useState定义的set方法在onScanBarcodeResult中不生效
let hasPrint = false
let hasConnection = false
// 是否配置过，如果没有配置过，不让操作-全局
let hasConfig = false
let globalUpcValue = ''
let globalQrCodeValue = ''

let currentFlag = 'upc'
let locationForamt = 0
if (resIPV4.test(window.location.hostname)) {
  locationForamt = 'ip'
} else {
  locationForamt = 'domain'
}
// web记录当前的打印机设备
let selected_device
const getStoredRfPlant = () => localStorage.getItem('rfPlant') || ''
const ReprintPage = prpos => {
  const history = useHistory()
  const upcInputRef = useRef(null)
  const qrCodeInputRef = useRef(null)
  const [visibleFlag, setVisibleFlag] = useState(false)
  // web，sc（思创），Honeywell
  const [reprintType] = useState(prpos.reprintType || '')
  const [reworkFlag] = useState(prpos.reworkFlag || 0)
  const [relabelReason] = useState(prpos.relabelReason || null)
  const [relabelReworkTime] = useState(prpos.relabelReworkTime || null)
  const [cartonNo] = useState(prpos.cartonNo || null)
  const [connectionFlag, setConnectionFlag] = useState(false)
  // 是否配置过，如果没有配置过，不让操作-响应式变量
  const [configFlag, setConfigFlag] = useState(false)
  const [upcValidPass, setUpcValidPass] = useState(false)
  const [qrCodeValidPass, setQrCodeValidPass] = useState(false)
  const mac = useSelector(state => state.commonStore.mac)
  const [macState, setMacState] = useState('')
  const [upcValue, setUpcValue] = useState('')
  const [ipValue, setIpValue] = useState('')
  const [plantValue, setPlantValue] = useState(null)
  const [qrCodeValue, setQrCodeValue] = useState('')
  const [inputReadOnly, setInputReadOnly] = useState(false)
  const [configInfo, setConfigInfo] = useState({})
  const [skuInfo, setSkuInfo] = useState({})
  const [webDefaultDevice, setWebDefaultDevice] = useState({})
  const [printerIpMismatchWarning, setPrinterIpMismatchWarning] = useState(false)
  const [disableHoneywellIpConfirm, setDisableHoneywellIpConfirm] = useState(false)
  const [tourFlag] = useState(true)

  let initNetworkType = 'intranet'
  if (isExtranetHostname()) {
    // if (window.location.href.indexOf('extranet') !== -1) {
    // 外网
    initNetworkType = 'extranet'
  } else {
    // 内网
    initNetworkType = 'intranet'
  }
  const [networkType] = useState(initNetworkType)

  // 本次补充：统一收口 Honeywell + IP 场景判断，避免新增逻辑散落在页面各处。
  const isHoneywellReprint = reprintType === 'Honeywell'
  const isHoneywellIpMode = isHoneywellReprint && locationForamt === 'ip'
  const isHoneywellIpConfirmDisabled = isHoneywellIpMode && disableHoneywellIpConfirm

  const queryHeader = {
    isRF: true
  }
  // 本次补充：Honeywell + IP 场景下，plant 优先使用入口缓存值；其他场景仍走原逻辑。
  const getHoneywellStoredPlant = fallbackPlant => {
    if (!isHoneywellIpMode) {
      return fallbackPlant || null
    }
    return getStoredRfPlant() || fallbackPlant || null
  }

  // 本次补充：统一维护 Honeywell + IP 校验结果，失败时同时控制红字提示和按钮置灰。
  const setHoneywellIpValidationState = isPassed => {
    if (!isHoneywellIpMode) {
      return
    }
    setPrinterIpMismatchWarning(!isPassed)
    setDisableHoneywellIpConfirm(!isPassed)
  }

  // 本次补充：在用户重新编辑或关闭弹窗时，清理本次新增的失败态。
  const clearHoneywellIpValidationState = () => {
    setPrinterIpMismatchWarning(false)
    setDisableHoneywellIpConfirm(false)
  }

  // 页面初始化
  useEffect(() => {
    hasPrint = false
    const storedPlant = getHoneywellStoredPlant()
    if (storedPlant) {
      setPlantValue(storedPlant)
    }
    if (isHoneywellReprint) {
      setMacState(mac)
    }
    if (reprintType === 'web') {
      loadFingerprint()
    }
    qrCodeInputRef.current.focus({ cursor: 'all' })
    // 思创手持枪
    if (reprintType === 'sc') {
      // 设置功率，设置枪
      setReadSetting(1)
      // 获取设备号
      getDeviceInfo()
      onScanBarcodeResult(data => {
        console.log('currentFlag', currentFlag)
        console.log('扫码结果-data', data)
        switch (currentFlag) {
          case 'upc':
            checkValue(data, currentFlag)
            break
          case 'qrCode':
            checkValue(data, currentFlag)
            break
          default:
            break
        }
      })
      onKeyMsg(isStart => {
        console.log('Key Msg:', isStart)
        if (['upc', 'qrCode'].includes(currentFlag)) return
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (macState) {
      // 获取IP配置
      getPrintConfigFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [macState])
  // web端获取打印驱动中配置的默认打印机
  const getDefaultDeviceFun = cb => {
    //Get the default device from the application as a first step. Discovery takes longer to complete.
    BrowserPrint.getDefaultDevice(
      'printer',
      device => {
        setWebDefaultDevice(device)
        selected_device = device
        cb && cb()
      },
      error => {
        console.log('error', error)
        hasConfig = false
        setConfigFlag(false)
        errorMessageFun(
          {
            errorCode: 6001
          },
          'read_print'
        )
      }
    )
  }
  // 创建 FingerprintJS 加载器实例
  const loadFingerprint = async () => {
    const fp = await FingerprintJS.load() // 加载库
    const result = await fp.get() // 获取指纹数据
    setMacState(result.visitorId)
    // 保存指纹 ID
  }
  const getDeviceInfo = async () => {
    try {
      onAppData(data => {
        console.log('sn-data', data)
        if (!data) {
          showDeviceError()
          return
        }
        const code = data.sn
        if (!code) {
          showDeviceError()
          return
        }
        setMacState(code)
      })
      try {
        await getAppData()
      } catch (error) {
        showDeviceError()
      }
    } catch (err) {
      console.log('获取设备号失败：', err)
    }
  }
  const showDeviceError = () => {
    modalConfirm(
      {
        content: formatMessageNew('languageObj.defectiveReturnLocale.deviceError'),
        cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
        okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
        onCancel: () => {
          history.goBack()
        }
      },
      () => {
        clearAuthentication()
        history.push('/login')
      }
    )
  }
  const getPrintConfigFun = () => {
    let params = {
      deviceCode: macState
    }
    getPrintConfig(params, queryHeader).then(res => {
      let dt = res.resultData || {}
      setConfigInfo(dt)
      if (reprintType === 'web') {
        setPlantValue(dt.plant || null)
      }
      if (dt.ip) {
        if (reprintType === 'web' && networkType === 'extranet') {
          // 本地获取打印机，并检查联机状态
          getDefaultDeviceFun(() => {
            selected_device.read(
              () => {
                hasConnection = true
                setConnectionFlag(true)
              },
              err => {
                hasConnection = false
                setConnectionFlag(false)
                errorMessageFun(
                  {
                    errorCode: 6001
                  },
                  'read_print'
                )
              }
            )
          })
        } else {
          if (isHoneywellReprint) {
            if (isHoneywellIpMode) {
              checkPrinterStatusFun2(dt.ip, getHoneywellStoredPlant(dt.plant))
            } else {
              checkPrinterStatusFun(dt.ip)
            }
          } else {
            checkPrinterStatusFun(dt.ip)
          }
        }
        hasConfig = true
        setConfigFlag(true)
        qrCodeInputRef.current.focus({ cursor: 'all' })
      } else {
        hasConfig = false
        setConfigFlag(false)
        if (reprintType === 'web' && networkType === 'extranet') {
          // 本地获取打印机，并检查联机状态
          getDefaultDeviceFun(() => {
            selected_device.read(
              () => {},
              err => {
                errorMessageFun(
                  {
                    errorCode: 6001
                  },
                  'read_print'
                )
              }
            )
          })
        }
      }
    })
  }
  // 校验打印机状态
  const checkPrinterStatusFun = ip => {
    if (!ip) {
      return
    }
    let params = {
      printerIp: ip
    }
    checkPrinterStatus(params, queryHeader)
      .then(res => {
        let dt = res.resultData
        hasConnection = dt || false
        setConnectionFlag(dt || false)
      })
      .catch(err => {
        hasConnection = false
        setConnectionFlag(false)
        errorMessageFun(err)
        return
      })
  }

  const checkPrinterStatusFun2 = (ip, plant) => {
    if (!ip) {
      clearHoneywellIpValidationState()
      return Promise.resolve(false)
    }
    let params = {
      printerIp: ip,
      plant: plant
    }
    return checkPrinterStatus(params, queryHeader)
      .then(res => {
        let dt = res.resultData
        hasConnection = dt || false
        setConnectionFlag(dt || false)
        setHoneywellIpValidationState(!!dt)
        return dt || false
      })
      .catch(err => {
        hasConnection = false
        setConnectionFlag(false)
        if (`${err && err.errorCode}` === '8004') {
          setHoneywellIpValidationState(false)
        } else {
          errorMessageFun(err)
        }
        return false
      })
  }

  const onInputChange = (e, setFun, type) => {
    if (type === 'qrCode' || type === 'upc') {
      if (!hasConfig) {
        return
      }
      if (!hasConnection) {
        messageModal('error', {
          useWeb: true,
          content: formatMessageNew('languageObj.reprint.notConnection')
        })
        return
      }
      if (hasPrint) {
        messageModal('error', {
          useWeb: true,
          content: formatMessageNew('languageObj.reprint.clearNextScan')
        })
        return
      }
    }
    const value = e.target ? e.target.value.trim() : e
    const index = value.indexOf('/n')
    const newValue = index > -1 ? value.substring(0, index) : value
    setFun(newValue)
    if (type === 'printerIp' || type === undefined) {
      clearHoneywellIpValidationState()
    }
    if (type === 'upc') {
      globalUpcValue = newValue
    }
    if (type === 'qrCode') {
      globalQrCodeValue = newValue
    }
  }
  useEffect(() => {
    if (!upcValue) {
      setUpcValidPass(false)
      setSkuInfo({})
    }
  }, [upcValue])

  useEffect(() => {
    if (!qrCodeValue) {
      setQrCodeValidPass(false)
    }
  }, [qrCodeValue])

  const onInputKeyDown = (e, type) => {
    if (e.keyCode === 13) {
      const value = e.target ? e.target.value : e
      checkValue(value, type)
    }
  }
  const checkValue = (value, type) => {
    if (type === 'qrCode' || type === 'upc') {
      if (!hasConfig) {
        return
      }
      if (!hasConnection) {
        messageModal('error', {
          useWeb: true,
          content: formatMessageNew('languageObj.reprint.notConnection')
        })
        return
      }
      if (hasPrint) {
        messageModal('error', {
          useWeb: true,
          content: formatMessageNew('languageObj.reprint.clearNextScan')
        })
        return
      }
    }
    if (type === 'qrCode') {
      let valueUpperCase = value.toUpperCase()
      if (valueUpperCase.indexOf('HTTPS') === -1 && valueUpperCase.length >= 12 && valueUpperCase.length <= 14) {
        setQrCodeValue('')
        globalQrCodeValue = ''
        setUpcValue(value)
        globalUpcValue = value
        relabelValidUpcFun(value).then(res => {
          if (res) {
            if (!globalQrCodeValue) {
              setTimeout(() => {
                qrCodeInputRef && qrCodeInputRef.current.focus({ cursor: 'all' })
              }, 100)
            }
          }
        })
      } else {
        setQrCodeValue(value)
        globalQrCodeValue = value
        relabelValidQrCodeFun(value).then(res => {
          if (res) {
            console.log(111, globalUpcValue)
            if (!globalUpcValue) {
              setTimeout(() => {
                upcInputRef && upcInputRef.current.focus({ cursor: 'all' })
              }, 100)
            }
          }
        })
      }
    }
    if (type === 'upc') {
      let valueUpperCase = value.toUpperCase()
      if (valueUpperCase.indexOf('HTTPS') !== -1 && valueUpperCase.length === 33) {
        setQrCodeValue(value)
        globalQrCodeValue = value
        setUpcValue('')
        globalUpcValue = ''
        relabelValidQrCodeFun(value).then(res => {
          if (res) {
            if (!globalUpcValue) {
              setTimeout(() => {
                upcInputRef && upcInputRef.current.focus({ cursor: 'all' })
              }, 100)
            }
          }
        })
      } else {
        setUpcValue(value)
        globalUpcValue = value
        relabelValidUpcFun(value).then(res => {
          if (res) {
            if (!globalQrCodeValue) {
              setTimeout(() => {
                qrCodeInputRef && qrCodeInputRef.current.focus({ cursor: 'all' })
              }, 100)
            }
          }
        })
      }
    }
  }
  // 校验upc
  const relabelValidUpcFun = async value => {
    if (value || upcValue) {
      let params = {
        upc: value || upcValue
      }
      let reslute = {}
      await relabelValidUpc(params, queryHeader)
        .then(res => {
          reslute = res
        })
        .catch(err => {
          reslute = err
        })
      if (reslute && reslute.resultData) {
        setSkuInfo(reslute.resultData)
      }
      if (reslute.errorCode !== '200') {
        errorMessageFun(reslute, 'upc')
        return false
      }
    }
    setUpcValidPass(true)
    console.log('upc通过')
    return true
  }
  // 校验qr
  const relabelValidQrCodeFun = async value => {
    if (value || qrCodeValue) {
      let params = {
        qrCode: value || qrCodeValue,
        cartonNo
      }
      if (reworkFlag) {
        params.reworkFlag = reworkFlag
        params.plant = plantValue || configInfo.plant
      }
      let reslute = {}
      await relabelValidQrCode(params, queryHeader)
        .then(res => {
          reslute = res
        })
        .catch(err => {
          reslute = err
        })
      if (reslute && reslute.resultData) {
        if (reslute.resultData.upc && !globalUpcValue) {
          setSkuInfo(reslute.resultData)
          setUpcValue(reslute.resultData.upc)
          setUpcValidPass(true)
          upcInputRef.current.focus({ cursor: 'all' })
        }
      }
      if (reslute.errorCode !== '200') {
        errorMessageFun(reslute, 'qr')
        return false
      }
    }
    setQrCodeValidPass(true)
    console.log('qr通过')
    return true
  }

  const errorMessageFun = (err, type) => {
    let strFormat = 'languageObj.reprint.errorcode_' + err.errorCode
    let str = formatMessageNew(strFormat)
    console.log(str)
    if (errorNum === 0) {
      errorNum = 1
      if (type === 'read_print') {
        modalError(
          {
            content: (
              <div>
                {str}
                {tourFlag && (
                  <div>
                    <Button
                      type="link"
                      className="p0"
                      onClick={() => {
                        openTourFun()
                      }}
                    >
                      {formatMessageNew('languageObj.reprint.settingSeeTour')}
                    </Button>
                  </div>
                )}
              </div>
            )
          },
          () => {
            if (type === 'upc') {
              setTimeout(() => {
                upcInputRef.current.focus({ cursor: 'all' })
              }, 100)
            }
            errorNum = 0
          }
        )
      } else {
        modalErrorRefreshCode(
          {
            content: str || err.errorMessage
          },
          () => {
            if (type === 'upc') {
              setTimeout(() => {
                upcInputRef.current.focus({ cursor: 'all' })
              }, 100)
            }
            errorNum = 0
          }
        )
      }
    }
  }
  const openTourFun = () => {
    modalInfo({
      title: formatMessageNew('languageObj.reprint.settingTour'),
      content: tourFun(),
      width: '50%'
    })
  }
  // web打印机配置指引
  const tourFun = () => {
    return (
      <div style={{ maxHeight: '45vh', overflow: 'auto' }}>
        <Steps
          current={0}
          direction="vertical"
          items={[
            {
              title: formatMessageNew('languageObj.reprint.settingStep1'),
              status: 'process',
              description: (
                <div className="fontS14">
                  {formatMessageNew('languageObj.reprint.settingTip1')}
                  <Button
                    type="link"
                    className="p0 fontS14"
                    style={{ height: 'auto' }}
                    onClick={() => {
                      downloadTem('/zebra-browser-print-windows-v132489.exe', 'zebra-browser-print-windows-v132489.exe')
                    }}
                  >
                    {formatMessageNew('languageObj.reprint.settingDown')}
                  </Button>
                  <div className="mt10">
                    <Image alt="PrintStep1" src={PrintStep1} />
                  </div>
                </div>
              )
            },
            {
              title: formatMessageNew('languageObj.reprint.settingStep2'),
              status: 'process',
              description: (
                <div className="fontS14">
                  {formatMessageNew('languageObj.reprint.settingTip2')}
                  <div className="mt10">
                    <Image alt="PrintStep2" src={PrintStep2} />
                  </div>
                  <div className="mt10">
                    <Image alt="PrintStep3" src={PrintStep3} />
                  </div>
                </div>
              )
            },
            {
              title: formatMessageNew('languageObj.reprint.settingStep3'),
              status: 'process',
              description: (
                <div className="fontS14">
                  {formatMessageNew('languageObj.reprint.settingTip3')}
                  <div className="mt10">
                    <Image alt="PrintStep4" src={PrintStep4} />
                  </div>
                </div>
              )
            },
            {
              title: formatMessageNew('languageObj.reprint.settingStep4'),
              status: 'process',
              description: (
                <div className="fontS14">
                  {formatMessageNew('languageObj.reprint.printSetting')}
                  <div className="mt10">
                    <Image alt="PrintStep5" src={PrintStep5} />
                  </div>
                </div>
              )
            }
          ]}
        />
      </div>
    )
  }
  // 更新 扳机事件 0 : 1 : 2 : 3 = ⽆状态 : Rfid读取模式 : 扫描条码模式 : RFIDduqu模式(扣动扳机读取，松开停止)
  const changeKeyCall = async key => {
    try {
      await setKeyCall(key, true)
    } catch (error) {
      console.error('Error overdueValidation setKeyCall:', error)
    }
  }
  const onInputFocus = key => {
    try {
      if (reprintType === 'sc') {
        currentFlag = key
        if (['upc', 'qrCode'].includes(key)) changeKeyCall(2)
      }
      setInputReadOnly(true)
      setTimeout(() => {
        setInputReadOnly(false)
      }, 100)
    } catch (error) {}
  }

  const clearInfoFun = () => {
    setUpcValue('')
    globalUpcValue = ''
    setQrCodeValue('')
    globalQrCodeValue = ''
    setSkuInfo({})
    setUpcValidPass(false)
    setQrCodeValidPass(false)
    hasPrint = false
    setTimeout(() => {
      qrCodeInputRef.current.focus({ cursor: 'all' })
    }, 200)
  }

  const backFirstPage = () => {
    let str = '/'
    if (localStorage.getItem('qrLogin')) {
      str = localStorage.getItem('qrLogin')
    }
    history.push(str)
  }
  const showPrintSetting = () => {
    setVisibleFlag(true)
    if (configInfo.ip) {
      setIpValue(configInfo.ip)
    }
    if (isHoneywellIpMode) {
      setPlantValue(getHoneywellStoredPlant())
    } else if (configInfo.plant) {
      setPlantValue(configInfo.plant)
    }
  }
  const handleCancel = preserveWebPlant => {
    setVisibleFlag(false)
    setIpValue('')
    if (isHoneywellIpMode) {
      setPlantValue(getHoneywellStoredPlant())
    } else if (preserveWebPlant && reprintType === 'web') {
      setPlantValue(plantValue)
    } else {
      setPlantValue(null)
    }
    clearHoneywellIpValidationState()
    qrCodeInputRef && qrCodeInputRef.current.focus({ cursor: 'all' })
  }
  const setPrintConfigFun = () => {
    if (ipValue) {
      if (!resIPV4.test(ipValue)) {
        messageModal('error', {
          useWeb: true,
          content: formatMessageNew('languageObj.reprint.ipFormat')
        })
        return
      }
    } else {
      messageModal('error', {
        useWeb: true,
        content: formatMessageNew('languageObj.reprint.errorcodeNoInput')
      })
      return
    }
    if (!plantValue) {
      messageModal('error', {
        useWeb: true,
        content: formatMessageNew('languageObj.reprint.errorcodeNoInput')
      })
      return
    }
    let params = {
      ...configInfo,
      deviceCode: macState,
      ip: ipValue,
      plant: plantValue
    }
    let checkPrinterStatusPromise = null
    if (isHoneywellIpMode) {
      checkPrinterStatusPromise = checkPrinterStatusFun2(ipValue, plantValue)
    } else {
      let params2 = {
        printerIp: ipValue
      }
      checkPrinterStatusPromise = checkPrinterStatus(params2, queryHeader)
    }
    checkPrinterStatusPromise
      .then(resCheck => {
        let dt = isHoneywellIpMode ? resCheck : resCheck.resultData
        if (dt) {
          clearHoneywellIpValidationState()
          setPrintConfig(params, queryHeader)
            .then(res => {
              handleCancel()
              getPrintConfigFun()
              qrCodeInputRef && qrCodeInputRef.current.focus({ cursor: 'all' })
            })
            .catch(err => {
              errorMessageFun(err)
            })
        }
      })
      .catch(errCheck => {
        errorMessageFun(errCheck)
        return
      })
  }
  // web端设置配置
  const setPrintConfigFunWeb = () => {
    if (webDefaultDevice.uid) {
    } else {
      messageModal('error', {
        useWeb: true,
        content: formatMessageNew('languageObj.reprint.errorcodeNoInput')
      })
      return
    }
    if (!plantValue) {
      messageModal('error', {
        useWeb: true,
        content: formatMessageNew('languageObj.reprint.errorcodeNoInput')
      })
      return
    }
    // 校验成功，尝试读取数据
    selected_device.read(
      () => {
        console.log('读取成功')
        let params = {
          ...configInfo,
          deviceCode: macState,
          ip: webDefaultDevice.uid && webDefaultDevice.uid.split(':')[0],
          plant: plantValue
        }
        setPrintConfig(params, queryHeader)
          .then(res => {
            handleCancel(true)
            getPrintConfigFun()
            qrCodeInputRef && qrCodeInputRef.current.focus({ cursor: 'all' })
          })
          .catch(err => {
            errorMessageFun(err)
          })
      },
      () => {
        errorMessageFun(
          {
            errorCode: 6001
          },
          'read_print'
        )
      }
    )
  }
  // 打印
  const gotoPrint = () => {
    console.log('打印')
    if (!macState) {
      backFirstPage()
      return
    }
    if (reprintType === 'web' && networkType === 'extranet') {
      // 先获取ZPL指令，再打印
      let paramsZpl = {
        qrCode: qrCodeValue,
        upc: upcValue,
        type: reprintType === 'web' ? 0 : 1,
        operator: macState,
        printerIp: webDefaultDevice.uid && webDefaultDevice.uid.split(':')[0],
        plant: configInfo.plant,
        fingerPrintId: macState
      }
      getReprintInfo(paramsZpl).then(res => {
        let dt = res.resultData
        let printerCmd = dt.printerCmd
        selected_device.send(
          printerCmd,
          sendRes => {
            // sendRes: {} 为成功
            hasPrint = true
            messageModal('success', {
              useWeb: true,
              content: formatMessageNew('languageObj.reprint.printerSuccess')
            })
            qrCodeInputRef && qrCodeInputRef.current.focus({ cursor: 'all' })
          },
          () => {
            errorMessageFun(
              {
                errorCode: 6001
              },
              'read_print'
            )
          }
        )
      })
      return
    }
    let params = {
      qrCode: qrCodeValue,
      upc: upcValue,
      type: reprintType === 'web' ? 0 : 1,
      operator: macState,
      printerIp: configInfo.ip,
      plant: reprintType === 'web' ? plantValue || configInfo.plant : plantValue,
      fingerPrintId: macState
    }
    if (reprintType === 'Honeywell' && relabelReason && cartonNo) {
      params.relabelReason = relabelReason
      params.relabelReworkTime = relabelReworkTime
      params.cartonNo = cartonNo
    }
    relabelPrint(params, queryHeader)
      .then(res => {
        hasPrint = true
        messageModal('success', {
          useWeb: true,
          content: formatMessageNew('languageObj.reprint.printerSuccess')
        })
        qrCodeInputRef && qrCodeInputRef.current.focus({ cursor: 'all' })
      })
      .catch(err => {
        errorMessageFun(err)
      })
  }
  let printDisabled = upcValidPass && connectionFlag
  if (qrCodeValue) {
    printDisabled = printDisabled && qrCodeValidPass
  }
  // 本次补充：Honeywell + IP 校验失败时，除了配置确认按钮，页面底部打印按钮也同步置灰。
  const getModalHtml = () => {
    let styleObj = {}
    if (reprintType !== 'web') {
      styleObj = { width: '80vw' }
    }
    return (
      <div style={styleObj}>
        <div className="displayFlex alignCenter mt30">
          <div className="bind_label1 fontS16">{formatMessageNew('languageObj.reprint.macAddressSN')}：</div>
          <div className="bind_label2 fontS16">{macState}</div>
        </div>

        <div className="displayFlex alignCenter mt30">
          <div className="bind_label1 fontS16">{formatMessageNew('languageObj.reprint.printerIP')}：</div>
          <div className="bind_label2 fontS16">
            <Input
              className="pt5 pb5"
              value={ipValue}
              allowClear
              placeholder={`${formatMessageNew('languageObj.reprint.placehilderIp')}`}
              onChange={e => onInputChange(e, setIpValue, 'printerIp')}
            />
            {printerIpMismatchWarning && (
              <div style={{ color: '#ff4d4f', fontSize: 14, marginTop: 8 }}>
                {formatMessageNew('languageObj.reprint.printerIpPlantMismatch')}
              </div>
            )}
          </div>
        </div>

        <div className="displayFlex alignCenter mt30">
          <div className="bind_label1 fontS16">{formatMessageNew('languageObj.reprint.site')}：</div>
          <div className="bind_label2 fontS16">
            {locationForamt === 'ip' && <span>{plantValue}</span>}
            {locationForamt === 'domain' && (
              <Input
                className="pt5 pb5"
                value={plantValue}
                allowClear
                placeholder={`${formatMessageNew('languageObj.commonLocale.placeholderInput')} ${formatMessageNew(
                  'languageObj.reprint.site'
                )}`}
                onChange={e => onInputChange(e, setPlantValue)}
              />
            )}
          </div>
        </div>
        <Row>
          <Col push={7} span={10}>
            <div className="displayFlex alignCenter justifyContentCenter mt30">
              <Button
                className="phone-btn3 reset-btn mt0"
                size="large"
                type="primary"
                disabled={isHoneywellIpConfirmDisabled}
                onClick={() => setPrintConfigFun()}
              >
                {formatMessageNew(`languageObj.commonLocale.confirmTitle`)}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
  const getModalHtmlWeb = () => {
    let styleObj = {}
    if (reprintType !== 'web') {
      styleObj = { width: '80vw' }
    }
    return (
      <div style={styleObj}>
        <div className="displayFlex alignCenter mt30">
          <div className="bind_label1 fontS16">{formatMessageNew('languageObj.reprint.macAddressSN')}：</div>
          <div className="bind_label2 fontS16">{macState}</div>
        </div>

        <div className="displayFlex alignCenter mt30">
          <div className="bind_label1 fontS16">{formatMessageNew('languageObj.reprint.printerIP')}：</div>
          <div className="bind_label2 fontS16">
            <Input
              className="pt5 pb5"
              value={webDefaultDevice.uid && webDefaultDevice.uid.split(':')[0]}
              allowClear
              disabled
              placeholder={`${formatMessageNew('languageObj.reprint.placehilderIp')}`}
            />
          </div>
        </div>

        <div className="displayFlex alignCenter mt30">
          <div className="bind_label1 fontS16">{formatMessageNew('languageObj.reprint.site')}：</div>
          <div className="bind_label2 fontS16">
            {locationForamt === 'ip' && (
              <Select
                placeholder={
                  formatMessageNew('languageObj.commonLocale.placeholderSelect') +
                  ' ' +
                  formatMessageNew('languageObj.reprint.site')
                }
                value={plantValue}
                onChange={e => onInputChange(e, setPlantValue)}
                style={{
                  width: '100%',
                  height: 32
                }}
              >
                {selecteOptions.map(itemSel => {
                  return (
                    <Select.Option key={itemSel.value} value={itemSel.value}>
                      <span>{itemSel.label}</span>
                    </Select.Option>
                  )
                })}
              </Select>
            )}
            {locationForamt === 'domain' && (
              <Input
                className="pt5 pb5"
                value={plantValue}
                allowClear
                placeholder={`${formatMessageNew('languageObj.commonLocale.placeholderInput')} ${formatMessageNew(
                  'languageObj.reprint.site'
                )}`}
                onChange={e => onInputChange(e, setPlantValue)}
              />
            )}
          </div>
        </div>
        <Row>
          <Col push={7} span={10}>
            <div className="displayFlex alignCenter justifyContentCenter mt30">
              <Button
                className="phone-btn3 reset-btn mt0"
                size="large"
                type="primary"
                onClick={() => {
                  setPrintConfigFunWeb()
                }}
              >
                {formatMessageNew(`languageObj.commonLocale.confirmTitle`)}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
  const disableInputFalg = !configFlag || (hasPrint && reprintType === 'web') || qrCodeValidPass || upcValidPass
  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 16
        }
      }}
    >
      <div
        style={{ height: 'auto', overflow: 'auto', marginLeft: -5, marginRight: -5 }}
        className="full-tag-wrapper qrcode-wrapper"
      >
        <div className="displayFlex alignCenter justifyContentFE mt10">
          <div onClick={showPrintSetting} style={{ cursor: 'pointer' }} className="displayFlex alignCenter fontS16">
            <div className="iconWrapper">
              <SettingOutlined />
              {connectionFlag ? (
                <div className="iconDiv">
                  <CheckOutlined style={{ color: 'green', fontSize: 12 }} />
                </div>
              ) : (
                <div className="iconDiv">
                  <ExclamationOutlined style={{ color: 'red', fontSize: 12 }} />
                </div>
              )}
            </div>
            <div className="ml8">{formatMessageNew('languageObj.reprint.printSetting')}</div>
          </div>
          {reprintType === 'web' && networkType === 'extranet' && tourFlag && (
            <QuestionCircleOutlined
              onClick={openTourFun}
              title="设置引导"
              className="ml5"
              style={{ fontSize: 14, cursor: 'pointer' }}
            />
          )}
        </div>
        <div className="displayFlex alignCenter mt30">
          <div className="bind_label3 fontS16">{formatMessageNew('languageObj.commonLocale.qrCode')}：</div>
          <div className="bind_label2 fontS16">
            <Input
              className="pt5 pb5"
              ref={qrCodeInputRef}
              value={qrCodeValue}
              allowClear
              disabled={disableInputFalg}
              readOnly={inputReadOnly}
              placeholder={
                upcValidPass
                  ? formatMessageNew('languageObj.reprint.placeholderQr')
                  : `${formatMessageNew('languageObj.commonLocale.pleaseScan')}${formatMessageNew(
                      'languageObj.commonLocale.qrCode'
                    )}`
              }
              onFocus={() => onInputFocus('qrCode')}
              onKeyDown={e => onInputKeyDown(e, 'qrCode')}
              onChange={e => onInputChange(e, setQrCodeValue, 'qrCode')}
            />
          </div>
        </div>

        <div className="displayFlex alignCenter mt30">
          <div className="bind_label3 fontS16">{formatMessageNew('languageObj.commonLocale.upc')}：</div>
          <div className="bind_label2 fontS16">
            <Input
              className="pt5 pb5"
              ref={upcInputRef}
              value={upcValue}
              readOnly={inputReadOnly}
              allowClear
              disabled={disableInputFalg}
              placeholder={`${formatMessageNew('languageObj.commonLocale.pleaseScan')}${formatMessageNew(
                'languageObj.commonLocale.upc'
              )}`}
              onFocus={() => onInputFocus('upc')}
              onKeyDown={e => onInputKeyDown(e, 'upc')}
              onChange={e => onInputChange(e, setUpcValue, 'upc')}
            />
          </div>
        </div>

        <div className="displayFlex alignCenter mt5">
          <div className="bind_label3 fontS16"></div>
          <div className="bind_label2 fontS16">
            <div style={{ minHeight: 28 }} className="color-primary">
              {skuInfo.sku}
            </div>
          </div>
        </div>
        {reprintType === 'web' && (
          <div className="displayFlex alignCenter justifyContentCenter">
            <img className="tipImg" alt="tip" src={TipImg} />
            {formatMessageNew('languageObj.reprint.inputTip')}
          </div>
        )}
        <div className="displayFlex alignCenter justifyContentCenter mt20">
          <Button onClick={clearInfoFun} style={{ width: '40%' }} className="phone-btn3 reset-btn mt0">
            {`${formatMessageNew('languageObj.commonLocale.clear')}`}
          </Button>
        </div>
        <Row justify="center">
          {reprintType !== 'web' && !relabelReason && !cartonNo && (
            <Col span={12}>
              <div className="displayFlex alignCenter justifyContentCenter flexDirectionC mt30">
                <Button style={{ height: 'auto' }} onClick={backFirstPage} type="text">
                  <div className="displayFlex alignCenter justifyContentCenter flexDirectionC">
                    <RollbackOutlined style={{ fontSize: 40, color: '#1677ff' }} />
                    <div>{`${formatMessageNew('languageObj.reprint.back')}`}</div>
                  </div>
                </Button>
              </div>
            </Col>
          )}

          <Col span={12}>
            <div className="displayFlex alignCenter justifyContentCenter flexDirectionC mt30">
              <Button style={{ height: 'auto' }} disabled={!printDisabled} onClick={gotoPrint} type="text">
                <div className="displayFlex alignCenter justifyContentCenter flexDirectionC">
                  <PrinterOutlined style={{ fontSize: 40, color: printDisabled && '#1677ff' }} />
                  <div>{`${formatMessageNew('languageObj.reprint.print')}`}</div>
                </div>
              </Button>
            </div>
          </Col>
        </Row>

        {reprintType === 'web' ? (
          <Modal className="nike_zoom" open={visibleFlag} onCancel={handleCancel} maskClosable={false} footer={null}>
            {networkType === 'extranet' ? getModalHtmlWeb() : getModalHtml()}
          </Modal>
        ) : (
          <ModalMobile
            style={{ '--adm-center-popup-max-width': '90vw' }}
            visible={visibleFlag}
            showCloseButton={true}
            content={getModalHtml()}
            onClose={handleCancel}
          ></ModalMobile>
        )}
      </div>
    </ConfigProvider>
  )
}
export default ReprintPage
